<div class="event-detail">

  @if(isLoading()){
  <div class="loader-wrap">
      <app-spinner-loader [width]="40" />
    </div>
  }@else {


  <a class="back-link" (click)="goBack()">
    <i class="pi pi-arrow-left"></i> Back to Events
  </a>

  

  @if (event(); as ev) {
    <!-- Main Event Card -->
    <div class="event-card">
      <div class="event-image">
        @if (ev.image) {
          <img [src]="ev.image" alt="Event Host Image" class="event-banner-img" />
        } @else {
          <div class="image-overlay">
            <i class="pi pi-calendar-plus overlay-icon"></i>
          </div>
        }
      </div>

      <div class="event-body">
        <h2 class="event-title">{{ ev.title }}</h2>
        <p class="event-desc">{{ ev.description }}</p>

        <div class="event-meta">
          <div class="meta-item">
            <span class="meta-icon-wrap date-icon">
              <i class="pi pi-calendar"></i>
            </span>
            <div>
              <p class="meta-label">Date</p>
              <p class="meta-value">{{ ev.dateFormatted }}</p>
            </div>
          </div>
          <div class="meta-item">
            <span class="meta-icon-wrap time-icon">
              <i class="pi pi-clock"></i>
            </span>
            <div>
              <p class="meta-label">Time</p>
              <p class="meta-value">{{ ev.timeRange }}</p>
            </div>
          </div>
          <div class="meta-item">
            <span class="meta-icon-wrap type-icon">
              <i class="pi pi-info-circle"></i>
            </span>
            <div>
              <p class="meta-label">Status</p>
              <p class="meta-value">{{ ev.status }}</p>
            </div>
          </div>
          <div class="meta-item">
            @if (ev.host.image) {
              <img [src]="ev.host.image" class="meta-icon-wrap" style="object-fit: cover; border-radius: 8px;" />
            } @else {
              <span class="meta-icon-wrap" style="background: #ede9fe; color: #7c3aed;">
                <i class="pi pi-user"></i>
              </span>
            }
            <div>
              <p class="meta-label">Host</p>
              <p class="meta-value">{{ ev.host.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

   <!-- Attendees Card -->
<div class="attendees-card">
  <div class="attendees-header">
    <h3>Attendees</h3>
    <span class="confirmed-count">{{ ev.totalAttendees }} confirmed</span>
  </div>

  @for (attendee of visibleAttendees(); track attendee.id) {
    <div class="attendee-row">
      @if (attendee.image) {
        <img [src]="attendee.image" [alt]="attendee.name" class="attendee-avatar-img" />
      } @else {
        <div class="attendee-avatar" [style.background]="attendee.avatarBg">
          {{ attendee.initials }}
        </div>
      }
      <div class="attendee-info">
        <p class="attendee-name">{{ attendee.name }}</p>
        <p class="attendee-email">{{ attendee.email }}</p>
      </div>
      <div class="attendee-status">
        <span class="status-text">{{ attendee.status }}</span>
        <span class="status-dot"></span>
      </div>
    </div>
  }

  @if (ev.attendees.length > ATTENDEES_LIMIT) {
    <a class="view-all-link" (click)="toggleAttendees()">
      {{ showAllAttendees() ? 'Show less' : 'View all attendees' }}
      <i class="pi" [ngClass]="showAllAttendees() ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
    </a>
  }
</div>
    <!-- Danger Zone -->
    @if (ev.status.toLowerCase() !== 'deleted') {
  <div class="danger-zone">
    <h3 class="danger-title">Danger Zone</h3>
    <p class="danger-desc">Once you delete this event, there is no going back. Please be certain.</p>
    <button class="delete-btn" (click)="deleteEvent()">
      <i class="pi pi-shield"></i> Delete Event
    </button>
  </div>
}

  }

  }
</div>